import {TrackingClientStateHolder} from '../helpers/clientState';
import {
  DataLayerQuickFilterEvent,
  DataLayerQuickFilterEventGA4,
} from './trackFilterSelection';

export type TileViewType = 'product' | 'model';
export const trackProductListTileView =
  ({tileView}: {tileView: TileViewType}) =>
  (clientState: TrackingClientStateHolder): DataLayerQuickFilterEvent => {
    const {currentPage} = clientState.getCurrent();

    const eventGA4: DataLayerQuickFilterEventGA4 = {
      event: 'filter',
      action: 'submit',
      label: 'filter_modal',
      value: null,
      content_name: currentPage?.page?.path || '',
      page_type: currentPage?.page?.type || '',
      page_type_id:
        currentPage?.type === 'detailed' ? `${currentPage.page?.id || ''}` : '',
      attribute_group: 'view',
      attributes: tileView,
    };

    return {
      GA4: eventGA4,
    };
  };
